import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Welcome to my personal page...
        </p>
      </header>
    </div>
  );
}

export default App;
